module.exports = {
  name: 'pro',
  environment: 'product',
  host: {
    client: '//www.eqxiu.com',
    cdn: '//as.eqh5.com',
    file: '//asset.eqh5.com',
    auth: '//www.eqxiu.com',
    service: '//service.eqxiu.com',
    passport: '//passport.eqxiu.com',
    font: '//font.eqh5.com',
    layout: '//lib.eqh5.com',
    mtopic: '//mtopic-api.eqxiu.com',
    morder: '//morder-api.eqxiu.com',
    eqshow: '//showker-api.eqxiu.com',
    topic: '//topic.eqxiu.com',
    mall: '//store.eqxiu.com',
    showker: '//showker.eqxiu.com',
    wap: '//wap.eqxiu.com',
    h5_preview: '//h5.eqxiu.com',
    h2_preview: '//h2.veqxiu.net',
    h5e_preview: '//h5.ebdan.net/ls/',
    gc_preview: '//hd.yiqixiua.com',
    video_preview: '//a.veqxiu.com',
    qiniu: '//upload.qiniup.com',
    favorite: '//mfavorite-api.eqxiu.com',
    video: '//video-1251586368.file.myqcloud.com',
    pay: '//pay.eqxiu.com',
    mp1: '//mp1-api.eqxiu.com',
    iom: '//iom-api.eqxiu.com'
  },
  wxConf: {
    // 微信
    WX_APP_ID: 'wx99021574b270dbc2',
    AUTHORIZE_URL: 'http://s1.eqxiu.com/get-weixin-code.html'
  },
  cosBucket: 'eqxiu',
  plugin: {
    vue: '//lib.eqh5.com/vue/2.5.13/vue.runtime.min.js',
    vueRouter: '//lib.eqh5.com/vue-router/3.0.1/vue-router.min.js',
    vuex: '//lib.eqh5.com/vuex/3.0.1/vuex.min.js',
    vueColor: '//lib.eqh5.com/vue-color/2.4.6/vue-color.min.js',
    axios: '//lib.eqh5.com/axios/0.17.1/axios.min.js',
    jquery: '//lib.eqh5.com/jquery/2.2.4/jquery.min.js',
    cropper: '//lib.eqh5.com/cropperjs/1.3.5/cropper.min.js',
    html2canvas: '//lib.eqh5.com/html2canvas/1.0.0-alpha.12/html2canvas.min.js',
    qrcode: '//lib.eqh5.com/@eqxiu/lrsjng.jquery-qrcode/0.14.0.1/jquery-qrcode.min.js',
    psd: '//lib.eqh5.com/psd.js/3.1.0/psd.min.js',
    coreJs: '//lib.eqh5.com/core-js/2.5.7/shim.min.js',
    qiniu2: '//lib.eqh5.com/qiniu-js/2.4.0/qiniu.min.js',
    qriously: '//lib.eqh5.com/vue-qriously/1.0.0/vue-qriously.min.js',
    wxapp: '//res.wx.qq.com/open/js/jweixin-1.3.2.js',
    wxsdk: '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
  }
}
